export default __webpack_public_path__ + "static/media/gallery_14.5db2dca2.jpg";